//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      showPicker: false,

      ThisName: "",
      ThisItem: {},

      DataList: [],
      ColumnNameList: []
    };
  },
  created() {
    if (
      this.controlItem &&
      this.controlItem.SelectDataList &&
      this.controlItem.SelectDataList.length > 0
    ) {


      this.DataList = this.controlItem.SelectDataList;
      this.ColumnNameList = this.controlItem.SelectDataList.map(m => m.Text);


      var dataItem = this.controlItem.SelectDataList.find(m=>m.Value == this.controlItem.ControlValue);
      if(dataItem){
        this.ThisName = dataItem.Text;
        this.ThisItem = dataItem;
      }

    }
  },

  methods: {

    async doEvent(){

      var $e = this.$cmd.checkEvent(this.controlItem,"OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;

    },   


    onPickerClick() {
      console.log("onPickerClick");
      this.showPicker = true;
    },

    async onConfirm(value, index) {
      console.log("onConfirm",value);
      this.ThisName = value;
      this.ThisItem = null;
      

      if (index >= 0) {
        this.ThisItem = this.DataList[index];
        this.controlItem.ControlValue = this.ThisItem.Value;
      }
      console.log("this.ThisItem ", this.ThisItem);      
      this.showPicker = false;

      await this.doEvent();
    },

    onHelpIconClick($event){
      console.log("OnHelpIconClick-$event",$event);
      if(this.controlItem && this.controlItem.HelperText){
        this.$msg.toast(this.controlItem.HelperText);
      }else{
        this.$msg.toast("没有找到帮助信息");
      }
    },

  }
};
